<div class="board-container" cdkDropListGroup>
  <div class="tasks-header-bar">
    <button mat-icon-button [matMenuTriggerFor]="filterMenu" #filterMenuTrigger="matMenuTrigger" aria-label="Filter">
      <mat-icon>filter_list</mat-icon>
    </button>

    <!-- Dropdown Menu -->
    <mat-menu #filterMenu="matMenu" class="event-filter-panel">
      <div class="filter-panel-content" (click)="$event.stopPropagation()">

        <!-- 1. Kalender Dropdown (mat-select) -->
        <mat-form-field appearance="outline" class="full-width-field">
          <mat-label>Calendar</mat-label>
          <mat-select [value]="selectedCalendarForTaskOverview" [compareWith]="functions.objectComparisonFunction"
            (selectionChange)="onCalendarSelectChange($event.value); filterMenuTrigger.closeMenu()">
            <mat-option *ngFor="let cal of filterCalendars" [value]="cal">
              {{ cal.summary }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </mat-menu>

  </div>

  <div class="kanban-board">

    <div class="kanban-column">
      <div class="column-header">Not started</div>
      <div class="task-list" id="notStartedList" cdkDropList [cdkDropListData]="backlog"
        [cdkDropListConnectedTo]="['progressList', 'doneList', 'onHoldList']"
        (cdkDropListDropped)="drop($event, 'Not started')">
        <div *ngFor="let task of backlog" cdkDrag [cdkDragData]="task" (dblclick)="editTask(task)">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: task }"></ng-container>
        </div>
      </div>
    </div>

    <div class="kanban-column">
      <div class="column-header">In progress</div>
      <div class="task-list" id="progressList" cdkDropList [cdkDropListData]="inProgressTasks"
        [cdkDropListConnectedTo]="['notStartedList', 'doneList', 'onHoldList']"
        (cdkDropListDropped)="drop($event, 'In progress')">
        <div *ngFor="let task of inProgressTasks" cdkDrag [cdkDragData]="task" (dblclick)="editTask(task)">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: task }"></ng-container>
        </div>
      </div>
    </div>

    <div class="kanban-column" *ngIf="settings && settings.showOnHold">
      <div class="column-header">On hold</div>
      <div class="task-list" id="onHoldList" cdkDropList [cdkDropListData]="onHoldTasks"
        [cdkDropListConnectedTo]="['progressList', 'notStartedList', 'doneList']"
        (cdkDropListDropped)="drop($event, 'On hold')">
        <div *ngFor="let task of onHoldTasks" cdkDrag [cdkDragData]="task" (dblclick)="editTask(task)">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: task }"></ng-container>
        </div>
      </div>
    </div>

    <div class="kanban-column">
      <div class="column-header">Done</div>
      <div class="task-list" id="doneList" cdkDropList [cdkDropListData]="doneTasks"
        [cdkDropListConnectedTo]="['progressList', 'notStartedList', 'onHoldList']"
        (cdkDropListDropped)="drop($event, 'Done')">
        <div *ngFor="let task of doneTasks" cdkDrag [cdkDragData]="task" (dblclick)="editTask(task)">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: task }"></ng-container>
        </div>
      </div>
    </div>

  </div>

  <button *ngIf="selectedCalendarForTaskOverview && selectedCalendarForTaskOverview.id > -1" mat-fab color="primary" class="fab-bottom-right" (click)="addTask()"
    matTooltip="Add task">
    <mat-icon>add</mat-icon>
  </button>
</div>

<ng-template #taskCard let-task>
  <div class="custom-task-card">
    <div class="card-accent" [style.background-color]="getPriorityColor(task.priority)"></div>

    <div class="card-main-content" [ngStyle]="getTaskCardStyle(task)">
      <div class="task-title">{{task.title}}</div>
      <div class="task-date"
        [ngStyle]="{'color': (overDue(task) > 0) ? 'red' : 'inherit', 'font-weight': (overDue(task) > 2) ? 'bold' : 'normal'}">
        {{ (task.dueDate || task.creationDate) | date:'mediumDate' }}
      </div>

    </div>
  </div>
</ng-template>